import styled from 'styled-components'
import ReactSVG from 'react-svg'
import { Button, Select } from 'antd'
import { Head } from '../../../../styles'
import { styleguide } from '../../../../constants'

const { colors } = styleguide

const Page = styled.div`
  padding: 4rem 3.2rem;
`

Page.Head = styled(Head)`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 0;
`

Page.Head.Button = styled(Button)`
  && {
    height: 4rem;
    padding: 0 2rem;
  }
`

const Column = styled.div``

Page.ControlBar = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 1.2rem 3rem;
  margin-top: 1.2rem;
`

Page.Control = styled.div`
  display: flex;
  align-items: center;
  min-width: 0;
`

Page.Control.Label = styled.span`
  color: ${colors.darkGreyOne};
  font-size: 1.1rem;
  margin-right: 1.2rem;
  text-transform: uppercase;
  white-space: nowrap;
`

Page.Control.Select = styled(Select)`
  && {
    width: 240px;
  }

  && .ant-select-selection {
    min-height: 3.6rem;
    border-color: ${colors.darkGreyThree};
    border-radius: 0.8rem;
    box-shadow: none;
  }

  && .ant-select-selection__rendered {
    line-height: 3.4rem;
    margin-right: 3.2rem;
  }

  && .ant-select-selection-selected-value {
    max-width: 100%;
    padding-right: 0;
  }

  && .ant-select-arrow {
    right: 1.2rem;
  }

  &&.ant-select-focused .ant-select-selection,
  && .ant-select-selection:focus,
  && .ant-select-selection:active {
    border-color: ${colors.blue};
    box-shadow: 0 0 0 2px rgba(0, 104, 255, 0.12);
  }
`

const Table = styled.div`
  margin: 3rem 0;
`

Table.Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`

Table.Head = styled.div`
  border-top: 0.1rem solid ${colors.darkGreyThree};
  border-bottom: 0.1rem solid ${colors.darkGreyThree};
  display: flex;
  align-items: center;
  padding: 1.3rem 0;
  margin-top: 1.5rem;
`

Table.Head.Column = styled.div`
  width: calc(50% - 5rem);
  font-weight: 700;

  &:not(:first-child) {
    padding-left: 1.5rem;
  }
`

Table.Label = styled.div`
  color: ${colors.blue};
  font-weight: 600;
  white-space: nowrap;
`

Table.Body = styled.div``

Table.Column = styled.div`
  width: calc(50% - 5rem);
  display: flex;
  align-items: center;
  padding-right: 1.5rem;
  @media (max-width: 768px) {
    width: 100%;
  }
  &:not(:first-child) {
    border-left: 0.1rem solid ${colors.darkGreyThree};
    padding-left: 1.5rem;
  }
`

Table.Item = styled.div`
  border-bottom: 0.1rem solid ${colors.darkGreyThree};
  display: flex;
  justify-content: space-between;
  align-items: stretch;
  padding: 2rem 0;
`

Table.Item.Info = styled.div``

Table.Item.Organisation = styled.span``

Table.Events = styled.div`
  width: 10rem;
  border-left: 0.1rem solid ${colors.darkGreyThree};
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 1.5rem;
`

Table.EventLink = styled.a`
  display: inline-block;
  margin: 0 1.2rem;
`

Table.EventIcon = styled(ReactSVG)`
  height: 1.7rem;

  svg {
    width: 1.5rem;

    path {
      fill: ${colors.blue};
    }
  }
`

export { Page, Column, Table }
